import { render, staticRenderFns } from "./TimelineSolicitacoes.vue?vue&type=template&id=596ac2f9&scoped=true&"
import script from "./TimelineSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./TimelineSolicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./TimelineSolicitacoes.vue?vue&type=style&index=0&id=596ac2f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ac2f9",
  null
  
)

export default component.exports